module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAKCAYAAAB4zEQNAAAARklEQVQYlWP8//8/AwjI5X2AMBgYGB5NEmAE0UwwAWwArySjbO57uHHogAlmPjoAicOMRVeA4SCYArhCuFdIdxBObQwMDAAQxBIJy+AIbgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/export_ico.png
// module id = 0xE5
// module chunks = 1